<template>
  <div
    :class="`workpackage basic-flex-col ${workpackage_color}`"
  >
    <div class="basic-flex-row" style="justify-content: flex-start;">
      <TIcon
        v-if="getNewIcon(workpackage_icon)"
        :name="getNewIcon(workpackage_icon)"
        size="28"
        :color="textcolor"
        class="svg-icon"
      />
      <TText :color="textcolor" size="18" font_weight="400" :text="workpackage_token" />
      <TText :color="textcolor" class="ml-2" size="18" font_weight="400" :text="workpackage.name" />
    </div>
    <div class="basic-flex-row mt-2">
        <TText :color="textcolor" :text="workpackage.description" />
    </div>
    <div class="basic-flex-row mt-2" v-if="workpackage.time_effort_source">
      <TimeRecord
      style="width: 100%;"
      :equations="[
        {
          description: 'Plan',
          id: 'Plan',
          description_suffix: `(${$t('WorkpackageRework.Info.TimeRecord.TAKT')})`,
          /* label (string), label_size (number), icon (string), value (string), operator (string) */
          elements: [
            { label: 'Time Effort', id: 'Time Effort', icon: 'speedometer', value: workpackage.time_effort_source === 'time_effort_planned' ? workpackage.time_effort_planned : (workpackage[`${prefix}worksteps`].length === 0 ? workpackage.time_effort_steps : calcAllWorkStepsTotal({ workpackage, prefix: `${histprefix}${prefix}` }).value), unit: 'Mh', input_type: 'number', operator: '', is_disabled: true },
            { icon: '', value: '', operator: '/' },
            { label: 'Manpower', id: 'Manpower', icon: 'person-standing', value: workpackage.manpower_planned, unit: 'M', input_type: 'number', input_mode: 'decimal', operator: '', is_disabled: true },
            { icon: '', value: '', operator: '=' },
            { label: 'Duration', id: 'Duration', icon: 'stopwatch', value: workpackage.manpower_planned > 0 ? (Math.round(((workpackage.time_effort_source === 'time_effort_planned' ? workpackage.time_effort_planned : (workpackage[`${prefix}worksteps`].length === 0 ? workpackage.time_effort_steps : calcAllWorkStepsTotal({ workpackage, prefix: `${histprefix}${prefix}` }).value)) / workpackage.manpower_planned) * 100) / 100) : 0, unit: 'h', input_type: 'number', operator: '', is_disabled: true },
          ],
        }
      ]"
      :background_color="workpackage_bg_hex"
      :foreground_color="workpackage_fg_hex"

      ></TimeRecord>
        
    </div>
  </div>
</template>
<script>
import colors from 'vuetify/lib/util/colors';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TimeRecord from '@/modules/WorkPackageWIP/TimeRecord.module.vue';
import {
  mapGetters,
  // mapActions
 } from 'vuex';
export default {
  name: 'WorkpackageInformation',
  props: ['workpackage', 'prefix', 'histprefix'],
  data: () => ({
  }),
  // updated(){
  //   console.log('workpackage updated');
  // },
  components: {
    TIcon,
    TimeRecord,
  },
  computed: {
    ...mapGetters('WorkPackage', [
      'getNewIcon',
    ]),
    ...mapGetters('ProjectStructure', [
      'calcAllWorkStepsTotal',
    ]),
    textcolor() {
      if (this.workpackage && this.workpackage.textcolor) {
        return this.workpackage.textcolor
      } else {
        return 'black'
      }
    },
    workpackage_color() {
      if (this.workpackage && !this.workpackage.color.includes('lighten') && !this.workpackage.color.includes('darken')){
        return `${this.workpackage.color} lighten-1`
      } else if (this.workpackage) {
        return `${this.workpackage.color}`
      } else {
        return false
      }
    },
    workpackage_icon() {
      if (this.workpackage){
        return this.workpackage.icon
      } else {
        return false
      }
    },
    workpackage_token() {
      if (this.workpackage){
        return this.workpackage.token
      } else {
        return false
      }
    },
    // I dont like those here ... but I cant import the mixin here, I think?
    workpackage_fg_hex() {
      this.color_update_key;
      let textcolor = this.workpackage.textcolor;
      if (this.$store.state.View.font_color_settings.source === 'user'){
        return this.$store.state.View.font_color_settings.color;
      }
      if (textcolor.includes('black')) {
        return '#000'
      } else if (textcolor.includes('white')) {
        return '#FFF'
      } else {
        return colors[textcolor];
      }
    },
    workpackage_bg_hex() {
      if (this.isShowOwnWps && this.getOwnTWorkPackages(this.project_id).length !== 0 && !this.getOwnTWorkPackages(this.project_id).includes(this.workpackage.id)) {
        return '#616161';
      } else {
        let color = this.workpackage.color;
        if (color.includes('black')) {
          return '#000';
        } else if (color.includes('white')) {
          return '#FFF';
        } else {
          let color_parts = color.split(' ');
          if (color_parts.length === 1) {
            color_parts.push('lighten-1');
          }
          let color_part_first = color_parts[0].split("-");
          color_parts[0] = `${color_part_first[0]}${color_part_first.length > 1?color_part_first[1].substring(0,1).toUpperCase():''}${color_part_first.length > 1?color_part_first[1].substring(1):''}`;

          color_parts[1] = color_parts[1].replace("-","");

          if (colors[color_parts[0]]) {
            // vuetify standard colors
            return colors[color_parts[0]][color_parts[1]];
          } else {
            // vuetify theme colors -> old values
            let theme_colors = this.$vuetify.theme.themes[this.$vuetify.theme.isDark?'dark':'light'];
            if (theme_colors[color]) {
              return theme_colors[color];
            } else {
              // default value yellow lighten-1
              return '#ffee58';
            }
          }
        }
      }

    },
   
  },
  methods: {
  }
}
</script>
<style scoped>
  .workpackage {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0px;
    margin-bottom: 2px;
    padding: 4px;
    /* v-card css */
    border-width: thin;
    display: block;
    max-width: 100%;
    outline: none;
    text-decoration: none;
    transition-property: box-shadow,opacity;
    overflow-wrap: break-word;
    position: relative;
    white-space: normal;
    flex-shrink: 0;
  }
  
  .workpackage-token {
    /* margin-left: auto;
    margin-right: auto; */
    color: black;
    font-size: calc(12px * var(--taktplan_zoom));
    user-select: none;
  }
  .svg-icon {
    zoom: var(--taktplan_zoom);
  }

</style>
